export const ModerationTypeShortNames = {
    0: '',
    1: 'a',
    2: 'v',
    3: 'lms',
    4: 'v',
    5: 's',
    6: 's'
}

export enum ModerationType {
    'Default' = 0,
    'Hsedesign' = 1,
    'Own' = 2,
    'LMS' = 3,
    'OwnWithoutTag' = 4,
    'Standard' = 5,
    'StandardWithoutTag' = 6,
    'Channel' = 7,
    'ChannelGroupOrCourse' = 8
}

export const isTeamChannel = (type: ModerationType) => {
    return {
        isChannel: [ModerationType.Channel, ModerationType.ChannelGroupOrCourse]?.includes(type),
        channelType: type
    }
}export const ModerationTypeShortNames = {
    0: '',
    1: 'a',
    2: 'v',
    3: 'lms',
    4: 'v',
    5: 's',
    6: 's'
}

export enum ModerationType {
    'Default' = 0,
    'Hsedesign' = 1,
    'Own' = 2,
    'LMS' = 3,
    'OwnWithoutTag' = 4,
    'Standard' = 5,
    'StandardWithoutTag' = 6,
    'Channel' = 7,
    'ChannelGroupOrCourse' = 8
}

export const isTeamChannel = (type: ModerationType) => {
    return {
        isChannel: [ModerationType.Channel, ModerationType.ChannelGroupOrCourse]?.includes(type),
        channelType: type
    }
}